<template>
    <div class="max-w-md mx-auto px-6">
        <div class="flex items-center justify-between">
            <router-link :to="{path: '/'}"><img src="/static/img/tooddoc.png" alt="Tooddoc" class="h-4"></router-link>
            <div class="flex flex-col items-end md:flex-row">
                <button @click="showLanguageSwitcher" class="block appearance-none bg-transparent text-white outline-0 text-sm text-right mb-3 md:mb-0 md:mr-4">
                    <span v-text="patientLanguageName"></span> <span class="icon"><i class="mdi mdi-chevron-down"></i></span>
                </button>
                <button @click="logout" class="text-blue-lightest text-sm" v-if="userId">{{ $t('Sign_out') }}</button>
                <button @click="showLogin" class="text-white text-sm" v-else>{{ $t('Sign_in') }}</button>
            </div>
        </div>

        <login-modal :active="showLoginModal" @close="hideLogin"></login-modal>
        <logout-modal :active="showLogoutModal"></logout-modal>
        <language-switcher-modal :active="showLanguageSwitcherModal" @close="hideLanguageSwitcher"></language-switcher-modal>
    </div>
</template>
<script>
import helpers from '@/mixins/helpers'

import LoginModal from '@/components/Patient/LoginModal.vue'
import LogoutModal from '@/components/Patient/LogoutModal.vue'
import LanguageSwitcherModal from '@/components/Patient/LanguageSwitcherModal.vue'

export default {
    name: 'HeaderNav',

    mixins: [helpers],

    components: {LoginModal, LogoutModal, LanguageSwitcherModal},

    data: () => ({
        showLoginModal: false,
        showLogoutModal: false,
        showLanguageSwitcherModal: false,
    }),

    methods: {
        logout () {
            this.showLogoutModal = true
            setTimeout(() => {
                this.$store.dispatch('logout')
                // this.showLogoutModal = false
            }, 1000)
        },

        showLogin () {
            this.showLoginModal = true
        },

        hideLogin () {
            this.showLoginModal = false
        },

        showLanguageSwitcher () {
            this.showLanguageSwitcherModal = true
        },

        hideLanguageSwitcher () {
            this.showLanguageSwitcherModal = false
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Patient/HeaderNav.vue